if (document.getElementById('page-review')) {
  // pageReview()
}

function pageReview() {
  // reviewValidate()

  window.addEventListener('input', function (e) {
    // reviewValidate()
  })
}

const titleMin = 1

const textMin = 20
const textMax = 1000

function reviewValidate() {
  if (!document.getElementsByClassName('js-reviewValidate')[0]) {
    return
  }

  let submitError = false
  let titleError = false
  let textError = false

  const starItem = document.querySelector('.js-reviewValidate--star:checked')
  const starCount = parseInt(starItem.value, 10)

  const titleInput = document.querySelector('.js-reviewValidate--title')
  const titleCount = strCount(titleInput.value)
  const titleErrorView = document.querySelector('.js-reviewValidate--titleErrorView')

  const textInput = document.querySelector('.js-reviewValidate--text')
  const textCount = strCount(textInput.value)
  const textErrorView = document.querySelector('.js-reviewValidate--textErrorView')

  // console.log({ starCount })
  // console.log({ titleCount })
  // console.log({ textCount })

  if (starCount <= 1) {
    // ★1はテキストが必須
    if (titleCount < titleMin) {
      titleError = true
      submitError = true
    }
    if (textCount < textMin || textCount > textMax) {
      textError = true
      submitError = true
    }
  }

  if (titleCount > 0) {
    if (titleCount < titleMin) {
      titleError = true
      submitError = true
    }
    if (textCount < textMin) {
      // タイトルがあるなら本文も必須
      textError = true
      submitError = true
    }
  }
  if (textCount > 0) {
    if (textCount < textMin || textCount > textMax) {
      textError = true
      submitError = true
    }
    if (titleCount < titleMin) {
      // 本文があるならタイトルも必須
      titleError = true
      submitError = true
    }
  }

  //    ###    #####   #####   ##      ##    ##
  //   ## ##   ##  ##  ##  ##  ##       ##  ##
  //  ##   ##  #####   #####   ##        ####
  //  #######  ##      ##      ##         ##
  //  ##   ##  ##      ##      ######     ##
  // 結果処理
  if (titleError) {
    titleErrorView.classList.add('active')
    titleInput.classList.add('redFrame')
  } else {
    titleErrorView.classList.remove('active')
    titleInput.classList.remove('redFrame')
  }
  if (textError) {
    textErrorView.classList.add('active')
    textInput.classList.add('redFrame')
  } else {
    textErrorView.classList.remove('active')
    textInput.classList.remove('redFrame')
  }

  const sendBtn = document.querySelector('.js-reviewValidate--send')

  if (submitError) {
    sendBtn.classList.add('is-disable')
  } else {
    sendBtn.classList.remove('is-disable')
  }
}
//   ####   #####   ##   ##  ##     ##  ######
//  ##     ##   ##  ##   ##  ####   ##    ##
//  ##     ##   ##  ##   ##  ##  ## ##    ##
//  ##     ##   ##  ##   ##  ##    ###    ##
//   ####   #####    #####   ##     ##    ##

/**
 * 文字数をカウントして返す
 * @param {string} text 文字列
 * @returns
 */
function strCount(text) {
  const segmenter = new Intl.Segmenter('ja', { granularity: 'grapheme' })
  return [...segmenter.segment(text)].length
}
